import { Button, Typography } from "@mui/material";
import { Warning as WarningIcon } from "@mui/icons-material";

export interface ConfirmationFormProps {
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
  title?: string;
  message?: string;
  confirmColor?: "error" | "warning" | "primary" | "secondary";
}

const ConfirmationForm = ({
  onConfirm,
  onCancel,
  confirmText = "Yes, Delete",
  cancelText = "Cancel",
  loading = false,
  title = "You are about to delete this project",
  message = "This action is permanent and cannot be undone.",
  confirmColor = "error",
}: ConfirmationFormProps) => {
  return (
    <div className="p-8 text-center">
      <WarningIcon
        sx={{
          fontSize: 64,
          color: "error.main",
          mx: "auto",
          mb: 3,
          display: "block",
        }}
      />

      <Typography
        variant="h5"
        className="text-gray-900 mb-4 font-bold text-2xl"
      >
        {title}
      </Typography>

      <Typography
        variant="body1"
        className="text-gray-600 mb-8 text-base leading-relaxed"
      >
        {message}
      </Typography>

      <div className="flex gap-4 justify-between">
        <Button onClick={onCancel} variant="outlined" disabled={loading}>
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color={confirmColor}
          disabled={loading}
        >
          {loading ? "Deleting..." : confirmText}
        </Button>
      </div>
    </div>
  );
};

export default ConfirmationForm;
